import React from "react";
import { DeleteOutlined, HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, DatePicker, Form, Input, notification, Popconfirm, Select, Table } from "antd";
import "./data_attendance_mechanic.css";
import useSWR from "swr";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import dayjs from "dayjs";
import { SearchOutlined } from "@ant-design/icons";

const DataAttMechanic: React.FC = () => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    const { userData } = useAuth();
    const [tableParams, setTableParams] = React.useState<any>({
        search: "",
        sortField: "id",
        sortOrder: "descend",
        startDate: "",
        endDate: ""
    });
    const fetcher = (url: string) => axios.get(url).then((res) => res.data);
    const queryStr = new URLSearchParams({
        warehouse_code: userData?.warehouse_code || "",
        search: tableParams.search,
        sortField: tableParams.sortField,
        sortOrder: tableParams.sortOrder,
        startDate: tableParams.startDate,
        endDate: tableParams.endDate
    }).toString();
    const { data, isLoading, mutate } = useSWR(userData?.warehouse_code ? `${process.env.REACT_APP_BACKEND_URL}/api/attendance-mechanic/list?${queryStr}` : null, fetcher);
    const handleTableChange = (pagination: any, filters: any, sorter: any) => {
        setTableParams({
            ...tableParams,
            sortField: sorter.field,
            sortOrder: sorter.order,
        });
    };
    const handleDelete = async (code: string, date: string) => {
        const serverDate = dayjs().format("DD/MM/YYYY");
        if (date !== serverDate) {
            notification.error({ message: "Error", description: "Dilarang ! Hanya Absensi Mechanic tanggal hari ini yang boleh dihapus" });
            return;
        }
        try {
            await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/attendance-mechanic/delete`, { data: { code_mechanic: code, date_trans: date } });
            notification.success({ message: "Success", description: "Data berhasil dihapus" });
            mutate();
        } catch (error) {
            notification.error({ message: "Error", description: "Gagal menghapus data" });
        }
    };

    const columns = [
        {
            title: "Action",
            key: "action",
            render: (_: any, record: any) => (
                <Popconfirm getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement} title="Are You Sure Delete Transaction?" onConfirm={() => handleDelete(record.code_mechanic, record.date_trans)} okText="Ya" cancelText="Tidak">
                    <Button type="text" danger icon={<DeleteOutlined />} />
                </Popconfirm>
            ),
        },
        {
            title: "Date Trans",
            dataIndex: "date_trans",
            key: "date_trans",
            sorter: true,
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
                <div style={{ padding: 8 }}>
                    <DatePicker.RangePicker
                        format="DD/MM/YYYY"
                        value={selectedKeys && selectedKeys.length === 2 ? [dayjs(selectedKeys[0], "DD/MM/YYYY"), dayjs(selectedKeys[1], "DD/MM/YYYY")] : null}
                        onChange={(dates, dateStrings) => setSelectedKeys(dateStrings || [])}
                        style={{ marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type="primary"
                        onClick={() => {
                            const start = selectedKeys && selectedKeys[0] ? selectedKeys[0] : "";
                            const end = selectedKeys && selectedKeys[1] ? selectedKeys[1] : "";
                            setTableParams((prev: any) => ({ ...prev, startDate: start, endDate: end }));
                            confirm();
                        }}
                        size="small"
                        style={{ width: 90, marginRight: 8 }}
                    > Search </Button>
                    <Button onClick={() => {
                        clearFilters();
                        setTableParams((prev: any) => ({ ...prev, startDate: "", endDate: "" }));
                        confirm();
                    }} size="small" style={{ width: 90 }}> Reset </Button>
                </div>
            ),
            onFilterDropdownOpenChange: (visible: boolean) => { },
            filterIcon: (filtered: boolean) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
            render: (text: string) => text
        },
        { title: "Mechanic", dataIndex: "name_mechanic", key: "name_mechanic", sorter: true },
        { title: "Code Mechanic", dataIndex: "code_mechanic", key: "code_mechanic", sorter: true },
        { title: "Foreman", dataIndex: "foreman", key: "foreman", sorter: true },
    ];

    return (

        <div id="i296" style={transformStyle}>
            <div className="gjs-grid-row" id="ilo0i">
                <div className="gjs-grid-column" id="i2ev6">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                title: (
                                    <>
                                        <span>Transaction Attendance Mechanic</span>
                                    </>
                                ),
                            },
                            {
                                href: "#/dashboard/attendance_mechanic",
                                title: "Attendance Mechanic",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="i3ddi">
                <div className="gjs-grid-column" id="i48op"></div>
            </div>
            <div className="gjs-grid-row" id="ip4zj">
                <div className="gjs-grid-column" id="ibypf">

                    <Table
                        columns={columns}
                        dataSource={data}
                        loading={isLoading}
                        onChange={handleTableChange}
                        rowKey={(record: any) => `${record.code_mechanic}_${record.date_trans}`}
                    />
                </div>
            </div>
        </div>
    );
};

export default DataAttMechanic;